//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function getDocumentSignersAvailableRoles(revisionId: number, config?: AxiosRequestConfig | undefined): Promise<Types.AvailableRolesDto[]> {
    let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/available-roles";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDocumentSignersAvailableRoles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDocumentSignersAvailableRoles?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDocumentSignersAvailableRoles(_response);
    });
}

function processGetDocumentSignersAvailableRoles(response: AxiosResponse): Promise<Types.AvailableRolesDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initAvailableRolesDto(item)
              );
            }
        return Promise.resolve<Types.AvailableRolesDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AvailableRolesDto[]>(null as any);
}

export function addDocumentSignersRole(documentId: number, roleId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/{documentId}/roles/{roleId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddDocumentSignersRole,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigAddDocumentSignersRole?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddDocumentSignersRole(_response);
    });
}

function processAddDocumentSignersRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function removeDocumentSignersRole(documentId: number, roleId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/{documentId}/roles/{roleId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveDocumentSignersRole,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveDocumentSignersRole?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveDocumentSignersRole(_response);
    });
}

function processRemoveDocumentSignersRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getDocumentsSigningStatus(revisionId: number, config?: AxiosRequestConfig | undefined): Promise<Types.DocumentSigningStatusDto[]> {
    let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/signing-status";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDocumentsSigningStatus,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDocumentsSigningStatus?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDocumentsSigningStatus(_response);
    });
}

function processGetDocumentsSigningStatus(response: AxiosResponse): Promise<Types.DocumentSigningStatusDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initDocumentSigningStatusDto(item)
              );
            }
        return Promise.resolve<Types.DocumentSigningStatusDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DocumentSigningStatusDto[]>(null as any);
}

export function updateRevisionDocumentsSigningStatus(revisionId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/{revisionId}/update";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateRevisionDocumentsSigningStatus,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigUpdateRevisionDocumentsSigningStatus?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateRevisionDocumentsSigningStatus(_response);
    });
}

function processUpdateRevisionDocumentsSigningStatus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function startRevisionSigning(revisionId: number, documentIds?: number[] | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/revision/{revisionId}?";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
    if (documentIds === null)
        throw new Error("The parameter 'documentIds' cannot be null.");
    else if (documentIds !== undefined)
        documentIds && documentIds.forEach(item => { url_ += "documentIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStartRevisionSigning,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigStartRevisionSigning?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStartRevisionSigning(_response);
    });
}

function processStartRevisionSigning(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function stopRevisionSigning(revisionId: number, documentIds?: number[] | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/revision/{revisionId}?";
    if (revisionId === undefined || revisionId === null)
      throw new Error("The parameter 'revisionId' must be defined.");
    url_ = url_.replace("{revisionId}", encodeURIComponent("" + revisionId));
    if (documentIds === null)
        throw new Error("The parameter 'documentIds' cannot be null.");
    else if (documentIds !== undefined)
        documentIds && documentIds.forEach(item => { url_ += "documentIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStopRevisionSigning,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigStopRevisionSigning?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStopRevisionSigning(_response);
    });
}

function processStopRevisionSigning(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function stopDocumentSigning(documentId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/document/{documentId}";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigStopDocumentSigning,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigStopDocumentSigning?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processStopDocumentSigning(_response);
    });
}

function processStopDocumentSigning(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function getSignerToResendNotifications(revision: number, config?: AxiosRequestConfig | undefined): Promise<Types.SignerToResendNotificationDto[]> {
    let url_ = getBaseUrl() + "/api/document-signing/revision/{revision}/resend-notification";
    if (revision === undefined || revision === null)
      throw new Error("The parameter 'revision' must be defined.");
    url_ = url_.replace("{revision}", encodeURIComponent("" + revision));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSignerToResendNotifications,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSignerToResendNotifications?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSignerToResendNotifications(_response);
    });
}

function processGetSignerToResendNotifications(response: AxiosResponse): Promise<Types.SignerToResendNotificationDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initSignerToResendNotificationDto(item)
              );
            }
        return Promise.resolve<Types.SignerToResendNotificationDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SignerToResendNotificationDto[]>(null as any);
}

export function resendNotificationToSigner(documentId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/document-signing/document/{documentId}/resend-notification";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResendNotificationToSigner,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResendNotificationToSigner?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResendNotificationToSigner(_response);
    });
}

function processResendNotificationToSigner(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetDocumentSignersAvailableRoles: Partial<AxiosRequestConfig> | null;
export function getGetDocumentSignersAvailableRolesRequestConfig() {
  return _requestConfigGetDocumentSignersAvailableRoles;
}
export function setGetDocumentSignersAvailableRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentSignersAvailableRoles = value;
}
export function patchGetDocumentSignersAvailableRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentSignersAvailableRoles = patch(_requestConfigGetDocumentSignersAvailableRoles ?? {});
}

let _requestConfigAddDocumentSignersRole: Partial<AxiosRequestConfig> | null;
export function getAddDocumentSignersRoleRequestConfig() {
  return _requestConfigAddDocumentSignersRole;
}
export function setAddDocumentSignersRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddDocumentSignersRole = value;
}
export function patchAddDocumentSignersRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddDocumentSignersRole = patch(_requestConfigAddDocumentSignersRole ?? {});
}

let _requestConfigRemoveDocumentSignersRole: Partial<AxiosRequestConfig> | null;
export function getRemoveDocumentSignersRoleRequestConfig() {
  return _requestConfigRemoveDocumentSignersRole;
}
export function setRemoveDocumentSignersRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveDocumentSignersRole = value;
}
export function patchRemoveDocumentSignersRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveDocumentSignersRole = patch(_requestConfigRemoveDocumentSignersRole ?? {});
}

let _requestConfigGetDocumentsSigningStatus: Partial<AxiosRequestConfig> | null;
export function getGetDocumentsSigningStatusRequestConfig() {
  return _requestConfigGetDocumentsSigningStatus;
}
export function setGetDocumentsSigningStatusRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentsSigningStatus = value;
}
export function patchGetDocumentsSigningStatusRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDocumentsSigningStatus = patch(_requestConfigGetDocumentsSigningStatus ?? {});
}

let _requestConfigUpdateRevisionDocumentsSigningStatus: Partial<AxiosRequestConfig> | null;
export function getUpdateRevisionDocumentsSigningStatusRequestConfig() {
  return _requestConfigUpdateRevisionDocumentsSigningStatus;
}
export function setUpdateRevisionDocumentsSigningStatusRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateRevisionDocumentsSigningStatus = value;
}
export function patchUpdateRevisionDocumentsSigningStatusRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateRevisionDocumentsSigningStatus = patch(_requestConfigUpdateRevisionDocumentsSigningStatus ?? {});
}

let _requestConfigStartRevisionSigning: Partial<AxiosRequestConfig> | null;
export function getStartRevisionSigningRequestConfig() {
  return _requestConfigStartRevisionSigning;
}
export function setStartRevisionSigningRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStartRevisionSigning = value;
}
export function patchStartRevisionSigningRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStartRevisionSigning = patch(_requestConfigStartRevisionSigning ?? {});
}

let _requestConfigStopRevisionSigning: Partial<AxiosRequestConfig> | null;
export function getStopRevisionSigningRequestConfig() {
  return _requestConfigStopRevisionSigning;
}
export function setStopRevisionSigningRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStopRevisionSigning = value;
}
export function patchStopRevisionSigningRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStopRevisionSigning = patch(_requestConfigStopRevisionSigning ?? {});
}

let _requestConfigStopDocumentSigning: Partial<AxiosRequestConfig> | null;
export function getStopDocumentSigningRequestConfig() {
  return _requestConfigStopDocumentSigning;
}
export function setStopDocumentSigningRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigStopDocumentSigning = value;
}
export function patchStopDocumentSigningRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigStopDocumentSigning = patch(_requestConfigStopDocumentSigning ?? {});
}

let _requestConfigGetSignerToResendNotifications: Partial<AxiosRequestConfig> | null;
export function getGetSignerToResendNotificationsRequestConfig() {
  return _requestConfigGetSignerToResendNotifications;
}
export function setGetSignerToResendNotificationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSignerToResendNotifications = value;
}
export function patchGetSignerToResendNotificationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSignerToResendNotifications = patch(_requestConfigGetSignerToResendNotifications ?? {});
}

let _requestConfigResendNotificationToSigner: Partial<AxiosRequestConfig> | null;
export function getResendNotificationToSignerRequestConfig() {
  return _requestConfigResendNotificationToSigner;
}
export function setResendNotificationToSignerRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResendNotificationToSigner = value;
}
export function patchResendNotificationToSignerRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResendNotificationToSigner = patch(_requestConfigResendNotificationToSigner ?? {});
}